<template>
    <main class="room">
        <room-docs></room-docs>
        <div class="room__main">
            <div class="room__messages">
                <consultation-info></consultation-info>
            </div>
        </div>
        <div class="room__sidebar">
            <div class="room__chat chat">
                <user-info></user-info>
                <div class="chat__body" ref="container">
                    <message :message="message" v-for="message in messages" :key="message.id"></message>
                </div>
                <div class="chat__bottom">
                    <strong class="chat__msg r-strong">Вы не можете писать сообщения после завершения консультации</strong>
                    <div class="chat__inputbox">
                        <textarea class="chat__input r-text-input textarea" disabled="" placeholder="Напишите текст сообщения..."></textarea>
                    </div>
                    <button class="chat__enter r-button button" disabled="">Отправить сообщение</button>
                </div>
            </div>
        </div>
    </main>
</template>

<script>

    import RoomDocs from "./RoomDocs";
    import UserInfo from "./UserInfo";
    import Message from './chat/Message.vue';
    import ConsultationInfo from "./ConsultationInfo";
    import store from './store/room-store';

    import {mapActions, mapState} from 'vuex';

    export default {
        store,
        name: 'InactiveRoom',
        components: {
            RoomDocs,
            Message,
            UserInfo,
            ConsultationInfo
        },
        computed: {
            ...mapState('chat', [
                'messages'
            ])
        },
        mounted() {
            this.getMessages();
        },
        methods: {
            ...mapActions('chat', [
                'getMessages',
            ])
        }
    }
</script>
